import script from "./AppointmentsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentsList.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentsList.vue?vue&type=style&index=0&id=8af3f2de&lang=scss"

const __exports__ = script;

export default __exports__